import { t } from 'lib/i18n'

import { CataloguePage } from './CataloguePage'

export const MaterialsCataloguePage = () => (
  <CataloguePage
    kind="MATERIAL"
    title={t('المواد', 'Materials')}
    description={t('قائمة المواد المرجعية التي تظهر كاقتراحات عند تعبئة قسم المواد الموردة في التقرير.', 'Reference list of materials suggested when filling in the delivered-materials section of a report.')}
    icon="box"
    itemLabel={t('مادة', 'material')}
  />
)
